import { Dispatch, Store } from 'redux';
import { IOrganisationUser } from '@liquid-state/pephealth-client';
import confirmCareTeamAssignmentImpact from '@utils/confirmCareTeamAssignmentImpact';
import waitForStoreUpdate from '@utils/waitForStoreUpdate';
import { editDirectChildOrganisationUser } from './actions';
import { DirectChildOrganisationUserEditValues, toDirectChildOrganisationUserEdit } from './edit';
import { selectDirectChildOrganisationUserEdit } from './selectors';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export type SubmitDirectChildOrganisationUserEditOptions = {
  currentUser: IOrganisationUser;
  values: DirectChildOrganisationUserEditValues;
  organisationSlug: string;
  userId: number;
  dispatch: Dispatch;
  store: Store;
  t: Translate;
};

/** Direct Child Organisation edit submit: preview-confirm only for Care Team Flag true→false. */
export default async function submitDirectChildOrganisationUserEdit({
  currentUser,
  values,
  organisationSlug,
  userId,
  dispatch,
  store,
  t,
}: SubmitDirectChildOrganisationUserEditOptions): Promise<void> {
  const edit = toDirectChildOrganisationUserEdit(currentUser, values);

  const runEdit = () => {
    dispatch(editDirectChildOrganisationUser(organisationSlug, userId, edit));
    return waitForStoreUpdate(store, state => [
      selectDirectChildOrganisationUserEdit(state, organisationSlug, userId).status === 'loading',
    ]);
  };

  if (Boolean(currentUser.careTeamMember) && values.careTeamMember === false) {
    await confirmCareTeamAssignmentImpact({
      organisationSlug,
      userId,
      dispatch,
      store,
      t,
      whenEmpty: 'proceed',
      onConfirm: runEdit,
    });
    return;
  }

  await runEdit();
}
